import { createFileRoute } from "@tanstack/react-router";
import { OTTAdvertisingServicePage } from "./services_.ott-advertising";

export const Route = createFileRoute("/services_/ott-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "OTT Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Targeted OTT & Streaming Platform Video Ads.",
      },
    ],
  }),
  component: OTTAdvertisingServicePage,
});
